import { render, staticRenderFns } from "./LableLayout.vue?vue&type=template&id=74d26a1c&scoped=true&"
import script from "./LableLayout.vue?vue&type=script&lang=js&"
export * from "./LableLayout.vue?vue&type=script&lang=js&"
import style0 from "./LableLayout.vue?vue&type=style&index=0&id=74d26a1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d26a1c",
  null
  
)

export default component.exports